module.exports = __webpack_public_path__ + "img/shipo-icon-weather-stormy.11ca20fb.svg";